import { MutationOptions, useMutation } from 'react-query';
import { AxiosError } from 'axios';
import { resetUser, ResetUserResponse } from './api';

export function useResetUser(
  options?: MutationOptions<ResetUserResponse, AxiosError, string>
) {
  return useMutation({
    mutationFn: (userId: string) => resetUser(userId),
    ...options,
  });
}
